export const SERVICE_CODE = 'DASHBOARD_CONSULTANT_ACTIVITY' + '_SERVICE';
